import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M39.5 43.9999H4.3C2.48039 43.9999 1 42.5196 1 40.6999V5.49995C1 3.68034 2.48039 2.19995 4.3 2.19995H39.5C41.3197 2.19995 42.8 3.68034 42.8 5.49995V40.6999C42.8 42.5196 41.3197 43.9999 39.5 43.9999ZM4.3 4.39995C3.69349 4.39995 3.2 4.89344 3.2 5.49995V40.6999C3.2 41.3065 3.69349 41.7999 4.3 41.7999H39.5C40.1065 41.7999 40.6 41.3065 40.6 40.6999V5.49995C40.6 4.89344 40.1065 4.39995 39.5 4.39995H4.3Z" fill="black"/>
</svg>
;
